<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-row no-gutters class="pa-5">
            <v-col cols="auto">
                <v-img
                    src="@/assets/redeem-voucher-code.png"
                    width="80"
                    height="80"
                ></v-img>
            </v-col>

            <v-col cols="6" class="ml-5">
                <h4 v-text="translations.title[lang]"></h4>
                <div
                    style="font-size: 0.875rem"
                    class="font-weight-medium mt-2"
                    v-text="translations.info[lang]"
                ></div>

                <v-row no-gutters align="center" class="mt-5">
                    <v-col cols="7">
                        <b-text-field
                            v-model="voucher"
                            :label="translations.voucherCode[lang]"
                            no-top-margin
                        ></b-text-field>
                    </v-col>

                    <v-btn
                        color="secondary"
                        class="text-capitalize ml-3"
                        depressed
                        @click="sendRequest()"
                        :loading="loading"
                    >
                        <v-icon
                            class="mr-2"
                            size="20"
                            v-text="icons.mdiArrowRight"
                        ></v-icon>
                        {{ translations.redeem[lang] }}
                    </v-btn>
                </v-row>
            </v-col>
        </v-row>

        <v-row
            no-gutters
            style="font-size: 0.875rem"
            class="font-weight-medium mt-10 ml-5"
        >
            <v-col cols="auto">
                <v-icon v-text="icons.mdiInformationOutline"></v-icon>
            </v-col>
            <v-col cols="7" class="ml-3">
                {{ translations.info2[lang] }}
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="500">
            <b-card
                :title="translations.notificationTitle[lang]"
                :submitBtn="false"
                :cancelText="{ el: 'Κλείσιμο', en: 'close', it: 'Chiudere' }"
                @cancel="dialog = false"
            >
                <div class="d-flex justify-center py-3">
                    <img
                        :src="
                            redeemNotification.image
                                ? redeemNotification.image
                                : ''
                        "
                        alt=""
                        width="120"
                        height="50"
                    />
                </div>

                <div class="subtitle-1 font-weight-medium py-3">
                    {{ redeemNotification.title }}
                </div>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import redeemVoucher from "@/store/modules/storePanel/redeem/redeemVoucher";

import { mdiArrowRight, mdiInformationOutline } from "@mdi/js";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import translations from "@/utils/translations/storePanel/redeemVoucher";

export default {
    name: "RedeemVoucherCode",

    mixins: [translations],

    data: () => ({
        icons: { mdiArrowRight, mdiInformationOutline },
    }),

    computed: {
        ...mapState(["superUser", "loading"]),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return this.$store.state.permissions.redemption
                ? this.$store.state.permissions.redemption.redeem_voucher
                : this.superUser;
        },

        voucher: {
            get() {
                return this.$store.state.storePanel.redeemVoucher.voucher;
            },
            set(val) {
                this.setVoucher(val);
            },
        },

        redeemNotification() {
            return this.$store.state.storePanel.redeemVoucher
                .redeemNotification;
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },
    },

    methods: {
        ...mapActions("storePanel/redeemVoucher", ["create"]),
        ...mapMutations("storePanel/redeemVoucher", ["setVoucher"]),
        ...mapMutations(["setDialog"]),

        sendRequest() {
            if (this.voucher != "") {
                let formData = {
                    voucher: this.voucher,
                };
                this.create(formData);
            }
        },
    },

    watch: {
        permission: {
            immediate: true,
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/storePanel/forbidden-gateway`
                    );
                }
            },
        },
    },

    beforeCreate() {
        if (!this.$store.state.storePanel.redeemVoucher) {
            this.$store.registerModule(
                ["storePanel", "redeemVoucher"],
                redeemVoucher
            );
        }
    },
};
</script>
